import { MapTool } from "ui-components";
import { create } from "zustand";

import { BookmarksStore, createBookmarksSlice } from "./bookmarks";
import { CustomSearchStore, createCustomSearchSlice } from "./custom-search";
import { GeolocationStore, createGeolocationSlice } from "./geolocation";
import { LegendStore, createLegendSlice } from "./legend";
import { MeasureStore, createMeasureSlice } from "./measure";
import { SearchStore, createSearchSlice } from "./search";
import { QueryStore, createQuerySlice } from "./query";

interface SharedState {
	currentMapToolView: MapTool | "features-info" | null;
}

interface SharedActions {
	closeMapTool: () => void;
	openMapTool: (tool: MapTool | "features-info") => void;
}

type SharedStore = SharedState & SharedActions;

export type RootStore = SharedStore &
	MeasureStore &
	CustomSearchStore &
	GeolocationStore &
	LegendStore &
	BookmarksStore &
	SearchStore &
	QueryStore;

export const useStore = create<RootStore>((...params) => ({
	currentMapToolView: null,
	closeMapTool: () => params[0]({ currentMapToolView: null }),
	openMapTool: (tool) => params[0]({ currentMapToolView: tool }),
	...createLegendSlice(...params),
	...createMeasureSlice(...params),
	...createCustomSearchSlice(...params),
	...createGeolocationSlice(...params),
	...createBookmarksSlice(...params),
	...createSearchSlice(...params),
	...createQuerySlice(...params),
}));

export const useCurrentMapToolView = () =>
	useStore((state) => state.currentMapToolView);

export const useCloseMapTool = () => useStore((state) => state.closeMapTool);

export const useOpenLegendTool = () =>
	useStore((state) => state.openLegendTool);

export const useOpenMeasureTool = () =>
	useStore((state) => state.openMeasureTool);

export const useOpenCustomSearchTool = () =>
	useStore((state) => state.openCustomSearchTool);

export const useOpenGeolocationTool = () =>
	useStore((state) => state.openGeolocationTool);

export const useBookmarksList = () => useStore((state) => state.bookmarksList);

export const useOpenMapTool = () => useStore((state) => state.openMapTool);

export const useCurrentSearchType = () =>
	useStore((state) => state.currentSearchType);

export const useSetCurrentSearchType = () =>
	useStore((state) => state.setCurrentSearchType);

export const useCurrentSearchInput = () =>
	useStore((state) => state.currentSearchInput);

export const useSetCurrentSearchInput = () =>
	useStore((state) => state.setCurrentSearchInput);
